export default __webpack_public_path__ + "static/media/team-jl.a162944f.png";